import { useContext } from "react"
import { CurrentGroupContext } from "source/groups/my/groups"
import TabView from "source/groups/my/groups/TabView"
import { Icon } from "source/shared/components"
import { Heading } from "@planningcenter/doxy-web"
import { Link, Navigate } from "react-router-dom"
import { usePcoChatEnabled } from "source/chat/hooks/usePcoChatEnabled"

export default function ChatIndex() {
  const group = useContext(CurrentGroupContext)
  const chatEnabled = group.abilities.conversations.can_read
  const pcoChatEnabled = usePcoChatEnabled()
  const hasAccess = chatEnabled && pcoChatEnabled

  if (!hasAccess) return <Navigate to={group.base_path} replace />

  return (
    <TabView>
      <section>
        <div className="d-f fd-c g-1 ai-c jc-c c-tint2 mt-8@md mt-4">
          <Icon symbol="general#text-message" className="fs-0" aria-hidden />
          <Heading
            text="Chat with your group!"
            level={2}
            size={2}
            color="tint2"
          />
          <p className="ta-c" style={{ maxWidth: 400 }}>
            Chat is now available throughout our entire site. Look for the new
            chat icon in the top navigation.
          </p>
          <Link
            to="#TODO-chat-drawer-fragment-route-with-group-filter"
            className="minor-btn secondary-btn btn"
            aria-label="Chat"
          >
            <Icon symbol="general#text-message" className="mr-4p" aria-hidden />
            Open Chat
          </Link>
        </div>
      </section>
    </TabView>
  )
}
